import { Box, Button, Typography } from '@mui/material'
import styles from './ActionRow.module.scss'

function ActionRow({ Icon, label, trailingIcon: TrailingIcon, onClick, compact = false }) {
  return (
    <Button
      type="button"
      variant="text"
      onClick={onClick}
      className={`${styles.row} ${compact ? styles.rowCompact : ''}`}
      sx={{
        justifyContent: 'flex-start',
        alignItems: 'center',
        borderRadius: '8px',
        width: '100%',
        px: '12px',
        backgroundColor: 'rgb(255 255 255 / 0.7)',
        '&:hover': {
          backgroundColor: 'rgb(255 255 255 / 0.6)',
        },
      }}
    >
      {Icon ? <Icon className={styles.icon} /> : null}
      <Typography
        component="span"
        className={styles.label}
        sx={{ fontWeight: 600 }}
      >
        {label}
      </Typography>
      {TrailingIcon ? (
        <Box
          component="span"
          className={styles.trailingWrap}
        >
          <TrailingIcon className={styles.trailingIcon} />
        </Box>
      ) : null}
    </Button>
  )
}

export default ActionRow
